import '../styles/HomePage.css';

const StepIntro = () => {
     return (
    <div className="home-container">
      <div className="instructions-card">
        <h1>Welcome to Your VIP Ryder Cup Experience Gift Selector</h1>

        <div className="instructions-section">
          <p>We’re thrilled to have you join the Nexeo Plastics Team for an unforgettable experience at this year’s Ryder Cup!</p>
          <p>To ensure your gifts arrive in time for the event, please submit your selections by 5:00 PM EST on July 25th.<br /><br />Gifts will be shipped to the address you provided on your order and are expected to arrive in September.</p>
          <p>&nbsp;</p>
          <h2>How It Works:</h2>
          <ol className="steps-list">
            <li>
              <strong>Provide Your Information</strong>
              <p>Enter your name, address, and contact details so we know where to send your order.</p>
            </li>
            <li>
              <strong>Choose Your Bundle</strong>
              <p>Select from our three premium gift options that best fits your needs.</p>
            </li>
            <li>
              <strong>Customize Your Selection</strong>
              <p>Add additional items to complement your gift (2 Standard items or 1 Premium item). You will be asked to do these selections 3 times.</p>
            </li>
            <li>
              <strong>Review and Submit</strong>
              <p>Check your order details and submit when you're ready!</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default StepIntro;
